import React, { Component } from "react";
import { connect } from "react-redux";
import { number } from "yup";
import CenteredPaper from "../layouts/CenteredPaper";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { getTextSnippet } from "../util/forms/getTextSnippet";
import { IrqTitle } from "../molecules/IrqTitle";
import EditActions from "../schema/misc/EditActions";
import ILearn from "../molecules/ILearn";
import { ModifyDataPointModal } from "../molecules/ModifyDataPointModal";
import { withMapUtils } from "../util/hocs/withMapUtils";
import { CountyLimitsContext } from "../context/CountyLimitsContext";
import { getDownPaymentMinimum } from "../util/getDownPaymentMinimum";
import { LoadingIndicator } from "../atoms/LoadingIndicator";

class PurchaseIrqConfirmationView extends Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      open: false,
      openDataName: null,
      firstTimeBuyer: localStorage.getItem("firstTimeBuyer"),
    };
    this.getPageData = this.getPageData.bind(this);
  }

  componentDidMount() {
    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
  };

  openModalWithData = (data) => {
    this.setState({ open: true, openDataName: data });
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <div className="main-confirmation-view-wrapper">
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I have{" "}
                <span onClick={() => this.openModalWithData("firstTimeBuyer")}>
                  {getTextSnippet("homeBuyerType", this.state)}
                </span>{" "}
                in the last 3 years.
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                My closing date is{" "}
                <span
                  onClick={() => this.openModalWithData("plannedClosingDate")}
                >
                  {getTextSnippet("closingDateAway", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I'm looking to buy a home located at{" "}
                <span onClick={() => this.openModalWithData("street")}>
                  {getTextSnippet("street", this.props.data)}
                </span>
                ,{" "}
                <span onClick={() => this.openModalWithData("city")}>
                  {getTextSnippet("city", this.props.data)}
                </span>
                ,{" "}
                <span onClick={() => this.openModalWithData("state")}>
                  {getTextSnippet("state", this.props.data)}
                </span>{" "}
                that will be my{" "}
                <span onClick={() => this.openModalWithData("occupancyType")}>
                  {getTextSnippet("occupancyType", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                It's a{" "}
                <span onClick={() => this.openModalWithData("propertyType")}>
                  {getTextSnippet("propertyType", this.props.data)}
                </span>{" "}
                with a purchase price of{" "}
                <span onClick={() => this.openModalWithData("price")}>
                  {getTextSnippet("price", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I'll provide a{" "}
                <span onClick={() => this.openModalWithData("downPayment")}>
                  {getTextSnippet("downPayment", this.props.data)}
                </span>{" "}
                down payment and my credit score is{" "}
                <span onClick={() => this.openModalWithData("creditScore")}>
                  {getTextSnippet("creditScore", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                My closing date is{" "}
                <span
                  onClick={() => this.openModalWithData("plannedClosingDate")}
                >
                  {getTextSnippet("plannedClosingDate", this.props.data)}
                </span>{" "}
                and I'm interested in these loan options:{" "}
                <span onClick={() => this.openModalWithData("loanOptions")}>
                  {getTextSnippet("loanOptions", this.props.data)}.
                </span>
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I am{" "}
                <span onClick={() => this.openModalWithData("isSelfEmployed")}>
                  {getTextSnippet("isSelfEmployed", this.props.data)}
                </span>
                , I am{" "}
                <span onClick={() => this.openModalWithData("isUsCitizen")}>
                  {getTextSnippet("isUsCitizen", this.props.data)}
                </span>
                , and I have{" "}
                <span onClick={() => this.openModalWithData("isVeteran")}>
                  {getTextSnippet("isVeteran", this.props.data)}
                </span>{" "}
                in the U.S. military.
              </p>
            </div>
            {this.props.data.isVeteran && (
              <div className="confirmation-view-paragraph-wrapper">
                <p className="confirmation-view-paragraph">
                  I am{" "}
                  <span
                    onClick={() => this.openModalWithData("disabledVeteran")}
                  >
                    {getTextSnippet("disabledVeteran", this.props.data)}
                  </span>
                  , and I have{" "}
                  <span
                    onClick={() => this.openModalWithData("vaFirstTimeUse")}
                  >
                    {getTextSnippet("vaFirstTimeUse", this.props.data)}
                  </span>
                  .
                </p>
              </div>
            )}
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I am{" "}
                <span
                  onClick={() => this.openModalWithData("hasRealEstateAgent")}
                >
                  {getTextSnippet("hasRealEstateAgent", this.props.data)}
                </span>{" "}
                a real estate agent, and I{" "}
                <span onClick={() => this.openModalWithData("isBuyingAsIs")}>
                  {getTextSnippet("isBuyingAsIs", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                <span onClick={() => this.openModalWithData("forSaleByOwner")}>
                  {getTextSnippet("forSaleByOwner", this.props.data)}
                </span>{" "}
                for sale by owner.{" "}
                <span onClick={() => this.openModalWithData("hasTitleCompany")}>
                  {getTextSnippet("hasTitleCompany", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                <span onClick={() => this.openModalWithData("hasWaivedEscrow")}>
                  {getTextSnippet("hasWaivedEscrow", this.props.data)}
                </span>{" "}
                escrow.*
              </p>
            </div>
          </div>
          <EditActions canSubmit={this.props.isValid} label="Looks Good!" />
        </CenteredPaper>
        <ModifyDataPointModal
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          setFirstTimeBuyer={(value) => {
            this.setState({ firstTimeBuyer: value });
            localStorage.setItem("firstTimeBuyer", value);
          }}
          data={{
            firstTimeBuyer: this.state.firstTimeBuyer,
            ...this.props.data,
          }}
          openDataName={this.state.openDataName}
          customFormEdit={this.props.customFormEdit}
          onFormEdit={this.props.onFormEdit}
          validationObject={{
            ...this.props.validationSchema.fields,
            price: number()
              .test(
                "price",
                "Your loan amount is too high with the given down payment.",
                (value) => {
                  if (!value) return false;
                  const downPaymentMinimum = getDownPaymentMinimum({
                    countyLimits,
                    county: this.props.data.county,
                    state: this.props.data.state,
                    countyFips: this.props.data.countyFips,
                    stateFips: this.props.data.stateFips,
                    loanAmount: value - this.props.data.downPayment,
                    propertyType: this.props.data.propertyType,
                    occupancyType: this.props.data.occupancyType,
                    lookingTo: "Purchase",
                    isFirstTimeHomebuyer:
                      this.state.firstTimeBuyer === null
                        ? "false"
                        : this.state.firstTimeBuyer,
                  });
                  const minimum = value * (downPaymentMinimum / 100);
                  return this.props.data.downPayment >= minimum;
                }
              )
              .required(),
            downPayment: number()
              .test(
                "downPayment",
                "You must exceed the minimum down payment required.",
                (value) => {
                  if (!value) return false;
                  const downPaymentMinimum = getDownPaymentMinimum({
                    countyLimits,
                    county: this.props.data.county,
                    state: this.props.data.state,
                    countyFips: this.props.data.countyFips,
                    stateFips: this.props.data.stateFips,
                    loanAmount: this.props.data.price - value,
                    propertyType: this.props.data.propertyType,
                    occupancyType: this.props.data.occupancyType,
                    lookingTo: "Purchase",
                    isFirstTimeHomebuyer:
                      this.state.firstTimeBuyer === null
                        ? "false"
                        : this.state.firstTimeBuyer,
                  });
                  const minimum =
                    this.props.data.price * (downPaymentMinimum / 100);
                  return value >= minimum;
                }
              )
              .required(),
          }}
        />
      </ILearn>
    );
  }
}

export default withSubmissionEffect(
  connect()(withMapUtils(PurchaseIrqConfirmationView))
);
